<template>
    <div class="border border-tc-gray-7 rounded-lg overflow-hidden">
        <div class="text-20 text-tc-gray-3" v-if="txtLabel != null">
            {{txtLabel}} <span v-if="isShowStar" class="text-eb1c24">*</span>
        </div>
        <div class="">
            <input class="text-tc-blue-1 p-4 text-18 w-full placeholder-tc-gray-1"
                v-model="content"
                :type="inputType"
                :placeholder="txtPlaceholder"
                @input="onChange()">
        </div>
    </div>
</template>
<script>
import RegxHelper from "@/helper/RegxHelper.js";

export default {
    name: "InputText",
    props: {
        //v-model
        inputValue: String,
        //props
        minLength: Number,
        maxLength: Number,
        isTextOnly: Boolean,
        isShowStar: { type: Boolean, default: false },
        isShowPassword: { type: Boolean, default: false },
        //text
        txtLabel: String,
        txtPlaceholder: String,
    },
    computed: {
        inputType: function() {
            return this.isShowPassword ? 'text' : 'password';
        },
    },
    data: function() {
        return {
            content: this.inputValue,
        };
    },
    methods: {
        onChange: function() {
            var result = this.content;

            if (this.isTextOnly) {
                result = RegxHelper.removeEmoji(result);
                result = RegxHelper.removeNumber(result);
                result = RegxHelper.removeSymbol(result);
            }

            this.content = result;
            this.$emit('update:inputValue', result);
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
